import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const InfoDialog = ({ message, onClose }) => (
  <Dialog open onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="border-[#3a3220] bg-[#0f0f0f] text-white sm:max-w-sm" data-testid="info-dialog">
      <DialogHeader>
        <DialogTitle className="text-lg font-extrabold text-[#e5b84a]">Informasi</DialogTitle>
        <DialogDescription className="text-sm font-bold text-white" data-testid="info-dialog-message">{message}</DialogDescription>
      </DialogHeader>
      <button onClick={onClose} className="kz-gold-btn rounded-full py-2.5 text-sm font-extrabold text-black" data-testid="info-dialog-close">Tutup</button>
    </DialogContent>
  </Dialog>
);

export const SavedPlayerBar = ({ saved, onUse, onClear, light = false }) => {
  if (!saved) return null;
  const cls = light ? "border-blue-200 bg-blue-50 text-slate-700" : "border-[#6b5a2a] bg-black/50 text-white";
  return (
    <div className={`mb-3 flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2 text-[11px] font-bold ${cls}`} data-testid="saved-player-bar">
      <span>Data tersimpan di perangkat ini: {saved}</span>
      <span className="flex gap-2">
        <button type="button" onClick={onUse} className="rounded-full bg-[#e5b84a] px-3 py-1 font-extrabold text-black" data-testid="saved-player-use">Pakai</button>
        <button type="button" onClick={onClear} className="rounded-full border border-current px-3 py-1" data-testid="saved-player-clear">Hapus</button>
      </span>
    </div>
  );
};
